export default __webpack_public_path__ + "static/media/location.943917ba.svg";